// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

// const QueriesManagement = () => {
//   const navigate = useNavigate();
//   const [queries, setQueries] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [pagination, setPagination] = useState({
//     skip: 0,
//     limit: 10,
//     total: 0
//   });
//   const [filters, setFilters] = useState({
//     queryType: "all",
//     search: ""
//   });

//   const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884d8"];

//   useEffect(() => {
//     fetchQueries();
//   }, [pagination.skip, filters]);

//   const fetchQueries = async () => {
//     try {
//       setLoading(true);
//       let url = `http://localhost:9000/bq/api/need-help/?skip=${pagination.skip}&limit=${pagination.limit}`;

//       if (filters.queryType !== "all") {
//         url += `&query_type=${filters.queryType}`;
//       }

//       if (filters.search) {
//         url += `&search=${filters.search}`;
//       }

//       const response = await fetch(url);
//       const data = await response.json();

//       setQueries(data.queries);
//       setPagination(prev => ({
//         ...prev,
//         total: data.total
//       }));
//     } catch (error) {
//       console.error("Error fetching queries:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePageChange = (newPage) => {
//     setPagination(prev => ({
//       ...prev,
//       skip: (newPage - 1) * prev.limit
//     }));
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//     setPagination(prev => ({ ...prev, skip: 0 }));
//   };

//   // Prepare data for charts
//   const getQueryTypeDistribution = () => {
//     const typeCounts = queries.reduce((acc, query) => {
//       acc[query.query_type] = (acc[query.query_type] || 0) + 1;
//       return acc;
//     }, {});

//     return Object.entries(typeCounts).map(([name, value]) => ({
//       name,
//       value
//     }));
//   };

//   const queryTypeData = getQueryTypeDistribution();

//   return (
//     <div className="p-6 bg-gray-100 min-h-screen">
//       <header className="flex justify-between items-center mb-3 bg-white p-3">
//         <h1 className="text-black text-xl font-bold ml-2">
//           Feedback & Queries Management
//         </h1>
//         <div className="flex space-x-6">
//           <button
//             onClick={() =>
//               navigate(
//                 "/dashboard/core-modules/feedback&queries/feedback-management"
//               )
//             }
//             className="btn "
//           >
//             Feedback management
//           </button>
//           <button
//             onClick={() =>
//               navigate(
//                 "/dashboard/core-modules/feedback&queries/queries-management"
//               )
//             }
//             className="btn text-black font-bold"
//           >
//             Queries management
//           </button>
//         </div>
//       </header>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
//         {/* Query Type Distribution Pie Chart */}
//         <div className="bg-white p-4 rounded-lg shadow">
//           <h2 className="text-lg font-semibold mb-4">Query Type Distribution</h2>
//           <div className="h-64">
//             {queryTypeData.length > 0 ? (
//               <ResponsiveContainer width="100%" height="100%">
//                 <PieChart>
//                   <Pie
//                     data={queryTypeData}
//                     cx="50%"
//                     cy="50%"
//                     labelLine={false}
//                     outerRadius={80}
//                     fill="#8884d8"
//                     dataKey="value"
//                     nameKey="name"
//                     label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
//                   >
//                     {queryTypeData.map((entry, index) => (
//                       <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                     ))}
//                   </Pie>
//                   <Tooltip />
//                 </PieChart>
//               </ResponsiveContainer>
//             ) : (
//               <div className="flex items-center justify-center h-full">
//                 <p className="text-gray-500">No data available</p>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Query Volume Bar Chart */}
//         <div className="bg-white p-4 rounded-lg shadow col-span-2">
//           <h2 className="text-lg font-semibold mb-4">Query Volume by Type</h2>
//           <div className="h-64">
//             {queryTypeData.length > 0 ? (
//               <ResponsiveContainer width="100%" height="100%">
//                 <BarChart data={queryTypeData}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="name" />
//                   <YAxis />
//                   <Tooltip />
//                   <Bar dataKey="value" fill="#8884d8" radius={[4, 4, 0, 0]}>
//                     {queryTypeData.map((entry, index) => (
//                       <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                     ))}
//                   </Bar>
//                 </BarChart>
//               </ResponsiveContainer>
//             ) : (
//               <div className="flex items-center justify-center h-full">
//                 <p className="text-gray-500">No data available</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="bg-white p-4 rounded-lg shadow mb-6">
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Query Type</label>
//             <select
//               name="queryType"
//               value={filters.queryType}
//               onChange={handleFilterChange}
//               className="w-full p-2 border border-gray-300 rounded-md"
//             >
//               <option value="all">All Types</option>
//               <option value="payment">Payment</option>
//               <option value="booking">Booking</option>
//               <option value="amenities">Amenities</option>
//               <option value="other">Other</option>
//             </select>
//           </div>
//           <div className="md:col-span-2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">Search</label>
//             <input
//               type="text"
//               name="search"
//               value={filters.search}
//               onChange={handleFilterChange}
//               placeholder="Search by name, email or message"
//               className="w-full p-2 border border-gray-300 rounded-md"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Queries Table */}
//       <div className="bg-white rounded-lg shadow overflow-hidden">
//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Message</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {loading ? (
//                 <tr>
//                   <td colSpan="6" className="px-6 py-4 text-center">
//                     <div className="flex justify-center">
//                       <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
//                     </div>
//                   </td>
//                 </tr>
//               ) : queries.length > 0 ? (
//                 queries.map((query) => (
//                   <tr key={query.id} className="hover:bg-gray-50">
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{query.id}</td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{query.name}</td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{query.email}</td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       <span className={`px-2 py-1 rounded-full text-xs ${
//                         query.query_type === 'payment' ? 'bg-blue-100 text-blue-800' :
//                         query.query_type === 'booking' ? 'bg-green-100 text-green-800' :
//                         'bg-gray-100 text-gray-800'
//                       }`}>
//                         {query.query_type}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 text-sm text-gray-500 max-w-xs truncate">{query.message}</td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       {new Date(query.created_at).toLocaleDateString()}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">
//                     No queries found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {!loading && queries.length > 0 && (
//           <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
//             <div className="flex-1 flex justify-between sm:hidden">
//               <button
//                 onClick={() => handlePageChange(Math.max(1, Math.floor(pagination.skip / pagination.limit)))}
//                 disabled={pagination.skip === 0}
//                 className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
//               >
//                 Previous
//               </button>
//               <button
//                 onClick={() => handlePageChange(Math.floor(pagination.skip / pagination.limit) + 2)}
//                 disabled={pagination.skip + pagination.limit >= pagination.total}
//                 className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
//               >
//                 Next
//               </button>
//             </div>
//             <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
//               <div>
//                 <p className="text-sm text-gray-700">
//                   Showing <span className="font-medium">{pagination.skip + 1}</span> to{' '}
//                   <span className="font-medium">{Math.min(pagination.skip + pagination.limit, pagination.total)}</span> of{' '}
//                   <span className="font-medium">{pagination.total}</span> results
//                 </p>
//               </div>
//               <div>
//                 <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
//                   {Array.from({ length: Math.ceil(pagination.total / pagination.limit) }, (_, i) => i + 1).map((page) => (
//                     <button
//                       key={page}
//                       onClick={() => handlePageChange(page)}
//                       className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
//                         page === Math.floor(pagination.skip / pagination.limit) + 1
//                           ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
//                           : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
//                       }`}
//                     >
//                       {page}
//                     </button>
//                   ))}
//                 </nav>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default QueriesManagement;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from 'recharts';

const QueriesManagement = () => {
  const navigate = useNavigate();
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    skip: 0,
    limit: 9,
    total: 0,
  });
  const [filters, setFilters] = useState({
    queryType: 'all',
    search: '',
  });

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8'];
  const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;

  useEffect(() => {
    fetchQueries();
  }, [pagination.skip, filters]);

  const fetchQueries = async () => {
    try {
      setLoading(true);
      let url = `${BQ_BASE_URL}/bq/api/need-help/?skip=${pagination.skip}&limit=${pagination.limit}`;

      if (filters.queryType !== 'all') {
        url += `&query_type=${filters.queryType}`;
      }

      if (filters.search) {
        url += `&search=${filters.search}`;
      }

      const response = await fetch(url);
      const data = await response.json();

      setQueries(data.queries);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
      }));
    } catch (error) {
      console.error('Error fetching queries:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      skip: (newPage - 1) * prev.limit,
    }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
    setPagination((prev) => ({ ...prev, skip: 0 }));
  };

  // Prepare data for charts and counts
  const getQueryTypeDistribution = () => {
    const typeCounts = queries.reduce((acc, query) => {
      acc[query.query_type] = (acc[query.query_type] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(typeCounts).map(([name, value]) => ({
      name,
      value,
    }));
  };

  const queryTypeData = getQueryTypeDistribution();

  // Get counts for each query type
  const getQueryTypeCounts = () => {
    const counts = {
      all: pagination.total,
      booking: 0,
      payment: 0,
      amenities: 0,
      other: 0,
    };

    queries.forEach((query) => {
      if (query.query_type === 'booking') counts.booking++;
      else if (query.query_type === 'payment') counts.payment++;
      else if (query.query_type === 'amenities') counts.amenities++;
      else counts.other++;
    });

    return counts;
  };

  const queryTypeCounts = getQueryTypeCounts();

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <header className="flex justify-between items-center mb-3 bg-white p-3">
        <h1 className="text-black text-xl font-bold ml-2">Queries Management</h1>
        <div className="flex space-x-6">
          <button
            onClick={() => navigate('/dashboard/core-modules/feedback&queries/feedback-management')}
            className="btn "
          >
            Feedback management
          </button>
          <button
            onClick={() => navigate('/dashboard/core-modules/feedback&queries/queries-management')}
            className="btn text-black font-bold"
          >
            Queries management
          </button>
        </div>
      </header>

      {/* Query Count Summary */}
      <div className=" mb-6 mt-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <div className="bg-white shadow-xl p-3 rounded-lg">
            <p className="text-sm text-black font-bold">Total Queries</p>
            <p className="text-2xl font-bold text-gray-600">{queryTypeCounts.all}</p>
          </div>
          <div className="bg-white p-3 rounded-lg shadow-xl">
            <p className="text-sm text-black font-bold">Reservations</p>
            <p className="text-2xl font-bold text-gray-600">{queryTypeCounts.booking}</p>
          </div>
          <div className="bg-white shadow-xl p-3 rounded-lg ">
            <p className="text-sm text-black font-bold">Payment</p>
            <p className="text-2xl font-bold text-gray-600">{queryTypeCounts.payment}</p>
          </div>
          <div className="bg-white p-3 rounded-lg shadow-xl">
            <p className="text-sm text-black font-bold">Amenities</p>
            <p className="text-2xl font-bold text-gray-600">{queryTypeCounts.amenities}</p>
          </div>
          <div className="bg-white p-3 rounded-lg shadow-xl">
            <p className="text-sm text-black font-bold">Other</p>
            <p className="text-2xl font-bold text-gray-600">{queryTypeCounts.other}</p>
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        {/* Left Column - Filters and Table */}
        <div className="lg:w-2/3">
          {/* Filters */}
          <div className="bg-white p-4 rounded-lg shadow mb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Query Type</label>
                <select
                  name="queryType"
                  value={filters.queryType}
                  onChange={handleFilterChange}
                  className="w-full p-2 border border-gray-300 rounded-md"
                >
                  <option value="all">All Types</option>
                  <option value="payment">Payment</option>
                  <option value="booking">Reservations</option>
                  <option value="amenities">Amenities</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Search</label>
                <input
                  type="text"
                  name="search"
                  value={filters.search}
                  onChange={handleFilterChange}
                  placeholder="Search by name"
                  className="w-full p-2 border border-gray-300 rounded-md text-sm"
                />
              </div>
            </div>
          </div>

          {/* Queries Table */}
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Name
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Email
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Type
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Message
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {loading ? (
                    <tr>
                      <td colSpan="6" className="px-6 py-4 text-center">
                        <div className="flex justify-center">
                          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
                        </div>
                      </td>
                    </tr>
                  ) : queries.length > 0 ? (
                    queries.map((query) => (
                      <tr key={query.id} className="hover:bg-gray-50">
                        <td className="px-3 py-4 whitespace-nowrap text-sm font-medium capitalize text-gray-900">
                          {query.name}
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                          {query.email}
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                          <span
                            className={`px-2 py-1 rounded-full text-xs ${
                              query.query_type === 'payment'
                                ? 'bg-blue-100 text-blue-800'
                                : query.query_type === 'booking'
                                  ? 'bg-green-100 text-green-800'
                                  : 'bg-gray-100 text-gray-800'
                            }`}
                          >
                            {query.query_type}
                          </span>
                        </td>
                        <td className="px-3 py-4 text-sm text-gray-500 max-w-xs truncate">
                          {query.message}
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                          {new Date(query.created_at).toLocaleDateString()}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">
                        No queries found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {!loading && queries.length > 0 && (
              <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                <div className="flex-1 flex justify-between sm:hidden">
                  <button
                    onClick={() =>
                      handlePageChange(Math.max(1, Math.floor(pagination.skip / pagination.limit)))
                    }
                    disabled={pagination.skip === 0}
                    className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                  >
                    Previous
                  </button>
                  <button
                    onClick={() =>
                      handlePageChange(Math.floor(pagination.skip / pagination.limit) + 2)
                    }
                    disabled={pagination.skip + pagination.limit >= pagination.total}
                    className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                  >
                    Next
                  </button>
                </div>
                <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                  <div>
                    <p className="text-sm text-gray-700">
                      Showing <span className="font-medium">{pagination.skip + 1}</span> to{' '}
                      <span className="font-medium">
                        {Math.min(pagination.skip + pagination.limit, pagination.total)}
                      </span>{' '}
                      of <span className="font-medium">{pagination.total}</span> results
                    </p>
                  </div>
                  <div>
                    <nav
                      className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                      aria-label="Pagination"
                    >
                      {Array.from(
                        {
                          length: Math.ceil(pagination.total / pagination.limit),
                        },
                        (_, i) => i + 1
                      ).map((page) => (
                        <button
                          key={page}
                          onClick={() => handlePageChange(page)}
                          className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
                            page === Math.floor(pagination.skip / pagination.limit) + 1
                              ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
                              : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
                          }`}
                        >
                          {page}
                        </button>
                      ))}
                    </nav>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Column - Charts */}
        <div className="lg:w-1/3">
          <div className="space-y-6">
            {/* Query Type Distribution Pie Chart */}
            <div className="bg-white p-4 rounded-lg shadow">
              <h2 className="text-lg font-semibold mb-4">Query Type Distribution</h2>
              <div className="h-64">
                {queryTypeData.length > 0 ? (
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        data={queryTypeData}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="value"
                        nameKey="name"

                        label={({ name, percent, x, y }) => (
                          <text
                            x={x}
                            y={y}
                            fill="#333"
                            fontSize="12" // 👈 smaller text size
                            textAnchor="middle"
                            dominantBaseline="middle"
                          >
                            {`${name} ${(percent * 100).toFixed(0)}%`}
                          </text>
                        )}
                      >
                        {queryTypeData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                ) : (
                  <div className="flex items-center justify-center h-full">
                    <p className="text-gray-500">No data available</p>
                  </div>
                )}
              </div>
            </div>

            {/* Query Volume Bar Chart */}
            <div className="bg-white p-4 rounded-lg shadow">
              <h2 className="text-lg font-semibold mb-4">Query Volume by Type</h2>
              <div className="h-64">
                {queryTypeData.length > 0 ? (
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={queryTypeData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Bar dataKey="value" fill="#8884d8" radius={[4, 4, 0, 0]}>
                        {queryTypeData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                ) : (
                  <div className="flex items-center justify-center h-full">
                    <p className="text-gray-500">No data available</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QueriesManagement;
